var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 41,
    viewBox: "0 0 22 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9748 21.0722L18.49 10.6517C18.2916 9.69256 17.3341 9 16.1991 9H5.80056C4.66493 9 3.70749 9.69256 3.50886 10.6517L0.0238014 21.0722C-0.00980651 21.1719 -0.00690351 21.2735 0.0267044 21.3656C0.00917468 21.4617 0.000354002 21.5528 0.000354002 21.6445C0.000354002 22.7492 1.04689 23.6481 2.33426 23.6481C3.45906 23.6481 4.4223 22.9577 4.61513 22.048L6.11978 17.2505L3.63123 27.6064C3.52203 27.8436 3.46699 28.0917 3.46699 28.3448C3.46699 29.4495 4.51375 30.3485 5.80112 30.3485H6.05491V38.9967C6.05491 40.1021 7.10166 41 8.38848 41C9.67495 41 10.7218 40.1011 10.7218 38.9967V30.3485H11.2795V38.9967C11.2795 40.1021 12.3261 41 13.6129 41C14.8997 41 15.9466 40.1011 15.9466 38.9967V30.3485H16.2009C17.4877 30.3485 18.534 29.4495 18.534 28.3448C18.534 28.0896 18.4789 27.8419 18.3696 27.6053L15.8824 17.2501L17.375 22.0068C17.5786 22.9577 18.5425 23.6481 19.6672 23.6481C20.9537 23.6481 22 22.7492 22 21.6445C22 21.5534 21.9908 21.4608 21.9736 21.3651C22.0056 21.2729 22.0085 21.1719 21.9748 21.0722Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 9C14.5328 9 17 6.98153 17 4.5C17 2.01847 14.5328 0 11.4997 0C8.46636 0 6 2.01847 6 4.5C6 6.98153 8.46716 9 11.4997 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.f03c8b71b5be75fda5b587c6b731de75.svg";
export { ForwardRef as ReactComponent };